// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"42371bfd","627":"d2b3aa1a","653":"3b532a41","738":"342f25fa","923":"85f6a478","938":"1cb7be4c"}[chunkId] + ".chunk.js";
};